/* gw: header — hide the cart count badge while the cart is empty (Figma 456:466 / 456:912 show no badge) */
(() => {
  const syncCount = (count) => {
    document.querySelectorAll('[data-gw-count]').forEach((badge) => {
      badge.dataset.gwCount = count;
    });
  };

  try {
    BoosterTheme.events.on('booster:cart:update', (minicart) => {
      if (minicart && minicart.data) syncCount(minicart.data.item_count);
    });
  } catch (error) {
    console.info('[gw-header] cart badge sync unavailable', error);
  }
})();

/* gw: header — the desktop menus open on click. A click on a top-level item opens its panel and a second click closes
 * it (neither loads the collection page; ctrl/cmd-click still does). Esc, a click elsewhere or another item also closes it. Hover does nothing
 * (CSS: sections/header--logo-top.liquid). */
(() => {
  const HOLDER = '.gw-header .main__navigation > .nav__link__holder';
  const panelOf = (holder) => holder.querySelector(':scope > .nav__submenu');
  const closeAll = (except) => {
    document.querySelectorAll(`${HOLDER}.is-open`).forEach((holder) => {
      if (holder === except) return;
      holder.classList.remove('is-open');
      const link = holder.querySelector(':scope > .nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  };

  document.querySelectorAll(HOLDER).forEach((holder) => {
    const link = holder.querySelector(':scope > .nav__link');
    if (!link || !panelOf(holder)) return;
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest(`${HOLDER} > .nav__link`);
    const holder = link && link.parentElement;
    if (holder && panelOf(holder)) {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      if (holder.classList.contains('is-open')) {
        closeAll();
        return;
      }
      closeAll(holder);
      holder.classList.add('is-open');
      link.setAttribute('aria-expanded', 'true');
      return;
    }
    if (event.target.closest && event.target.closest(`${HOLDER}.is-open`)) return;
    closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector(`${HOLDER}.is-open`);
    if (!open) return;
    closeAll();
    const link = open.querySelector(':scope > .nav__link');
    if (link) link.focus();
  });
})();
